<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="分类名称">
                <el-input v-model="queryForm.cateName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getYouzhicaiCategoryList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-refresh"
                        @click="updateCategory"
                    >更新
                    </el-button>
                    <!--                    <el-button-->
                    <!--                        type="primary"-->
                    <!--                        size="small"-->
                    <!--                        icon="el-icon-plus"-->
                    <!--                        @click="addYouzhicaiCategory"-->
                    <!--                    >新建-->
                    <!--                    </el-button>-->
                    <!--                    <el-button-->
                    <!--                        type="warning"-->
                    <!--                        plain-->
                    <!--                        size="small"-->
                    <!--                        icon="el-icon-edit"-->
                    <!--                        :disabled="multipleSelection.length != 1"-->
                    <!--                        @click="editYouzhicaiCategory(null)"-->
                    <!--                    >修改-->
                    <!--                    </el-button>-->
                    <!--                    <el-button-->
                    <!--                        type="danger"-->
                    <!--                        plain-->
                    <!--                        size="small"-->
                    <!--                        icon="el-icon-delete"-->
                    <!--                        :disabled="multipleSelection.length <= 0"-->
                    <!--                        @click="deleteYouzhicaiCategory(null)"-->
                    <!--                    >删除-->
                    <!--                    </el-button>-->
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                      <Icon color="#606266">
                        <Search />
                      </Icon>
                    </span>
<!--                    <span-->
<!--                        title="下载模板"-->
<!--                        class="icon-box"-->
<!--                        @click="importTemplate"-->
<!--                    >-->
<!--                      <Icon color="#606266">-->
<!--                        <ArrowDown />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        class="icon-box"-->
<!--                        title="导入数据"-->
<!--                        @click="isImport"-->
<!--                    >-->
<!--                      <Icon color="#606266">-->
<!--                        <ArrowExportUp24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        title="导出数据"-->
<!--                        class="icon-box"-->
<!--                        @click="exportYouzhicaiCategoryList"-->
<!--                    >-->
<!--                      <Icon color="#606266">-->
<!--                        <ArrowDownload24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
                    <span
                        class="icon-box"
                        @click="refreshYouzhicaiCategoryList"
                    >
                  <Icon color="#606266">
                    <Refresh />
                  </Icon>
                </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="youzhicaiCategoryList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="catePath"
                    label="分类层级"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="cateName"
                    label="分类名称"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="cateParentId"
                    label="父目录id"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="cateId"
                    label="分类id"
                    width="180"
                ></el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="youzhicaiCategoryStates[youzhicaiCategoryState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="youzhicaiCategory"
                        ref="youzhicaiCategoryForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="分类层级"
                            prop="catePath"
                        >
                            <el-input
                                size="small"
                                v-model="youzhicaiCategory.catePath"
                                :disabled="youzhicaiCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="分类名称"
                            prop="cateName"
                        >
                            <el-input
                                size="small"
                                v-model="youzhicaiCategory.cateName"
                                :disabled="youzhicaiCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="父目录id"
                            prop="cateParentId"
                        >
                            <el-input
                                size="small"
                                v-model="youzhicaiCategory.cateParentId"
                                :disabled="youzhicaiCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="分类id"
                            prop="cateId"
                        >
                            <el-input
                                size="small"
                                v-model="youzhicaiCategory.cateId"
                                :disabled="youzhicaiCategoryState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="youzhicaiCategoryState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetYouzhicaiCategoryList();
                this.getYouzhicaiCategoryList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetYouzhicaiCategoryList();
                this.getYouzhicaiCategoryList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                catePath: '', //分类层级
                cateName: '', //分类名称
                cateParentId: '', //父目录id
                cateId: '' //分类id
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            youzhicaiCategoryState: 'add',
            youzhicaiCategoryStates: {
                add: '新建youzhicai_category',
                check: '查看youzhicai_category',
                edit: '修改youzhicai_category'
            },

            multipleSelection: [],
            youzhicaiCategoryList: [],
            youzhicaiCategory: {
                catePath: '', //分类层级
                cateName: '', //分类名称
                cateParentId: '', //父目录id
                cateId: '' //分类id
            },
            btnLoading: false,

            rules: {
                catePath: [{ required: true, message: '分类层级不能为空', trigger: 'blur' }],
                cateName: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
                cateParentId: [{ required: true, message: '父目录id不能为空', trigger: 'blur' }],
                cateId: [{ required: true, message: '分类id不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getYouzhicaiCategoryList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetYouzhicaiCategoryList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.youzhicaiCategoryList = [];
        },
        resetDialog() {
            this.youzhicaiCategoryState = 'add';
            this.showDialog = false;
            this.queryForm = {
                catePath: '', //分类层级
                cateName: '', //分类名称
                cateParentId: '', //父目录id
                cateId: '' //分类id
            };
            this.getYouzhicaiCategoryList();
        },
        closeDialog() {
            this.showDialog = false;
            this.youzhicaiCategory = {
                catePath: '', //分类层级
                cateName: '', //分类名称
                cateParentId: '', //父目录id
                cateId: '' //分类id
            };
        },
        submitForm() {
            if (this.youzhicaiCategoryState == 'add') {
                this.$refs.youzhicaiCategoryForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/youzhicai/category/add`, { ...this.youzhicaiCategory }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetYouzhicaiCategoryList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.youzhicaiCategoryState == 'edit') {
                this.$refs.youzhicaiCategoryForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/youzhicai/category/edit`, { ...this.youzhicaiCategory }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetYouzhicaiCategoryList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addYouzhicaiCategory() {
            this.showDialog = true;
            this.youzhicaiCategoryState = 'add';
        },
        checkYouzhicaiCategory(youzhicaiCategoryId) {
            console.log(youzhicaiCategoryId);
            this.currentYouzhicaiCategoryId = youzhicaiCategoryId;

            this.getYouzhicaiCategoryById();
            this.showDialog = true;
            this.youzhicaiCategoryState = 'check';
        },
        editYouzhicaiCategory(youzhicaiCategoryId) {
            console.log('youzhicaiCategory', youzhicaiCategoryId);
            if (youzhicaiCategoryId) {
                this.currentYouzhicaiCategoryId = youzhicaiCategoryId;
                this.getYouzhicaiCategoryById();
            } else {
                this.youzhicaiCategory = { ...this.youzhicaiCategory, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.youzhicaiCategoryState = 'edit';
        },
        deleteYouzhicaiCategory(youzhicaiCategoryId) {
            let ids = '';
            if (youzhicaiCategoryId) {
                ids = youzhicaiCategoryId;
            } else {
                ids = this.multipleSelection.map((youzhicaiCategory) => youzhicaiCategory.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/youzhicai/category/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetYouzhicaiCategoryList();
                            this.getYouzhicaiCategoryList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshYouzhicaiCategoryList() {
            this.resetYouzhicaiCategoryList();
            this.getYouzhicaiCategoryList();
        },
        getYouzhicaiCategoryList(query = {}) {
            this.loading = true;
            get(`/youzhicai/category/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.youzhicaiCategoryList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getYouzhicaiCategoryById() {
            get(`/youzhicai/category/get`, { id: this.currentYouzhicaiCategoryId }).then((res) => {
                if (res.success) {
                    this.youzhicaiCategory = { ...this.youzhicaiCategory, ...res.youzhicaiCategory };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        updateCategory(){
            get(`/youzhicai/category/updateCategory`).then((res)=>{
                if(res.success){
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            })
        },
        /**
         * 导出信息
         */
        exportYouzhicaiCategoryList() {
            //this.btnLoading = true;
            exprotExcel(`/youzhicai/category/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/youzhicai/category/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/youzhicai/category/importData`, formData);
            this.refreshYouzhicaiCategoryList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getYouzhicaiCategoryList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getYouzhicaiCategoryList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>